import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    Name: { label: i18n.t('app.name'), value: '' },
    TaxType: { label: i18n.t('impuestos.TaxType'), value: '' },
    TaxRate: { label: i18n.t('impuestos.TaxRate'), value: '' },
    TaxCategory: { label: i18n.t('impuestos.TaxCategory'), value: '' },
    EquivalenceSurcharge: { label: i18n.t('impuestos.equivalence_surcharge'), value: '', type: 'number' }
  }
}
const getColumns = function getColumns () {
  return [
    { field: 'Name', title: i18n.t('app.name'), columnMenu: 'myTemplate', width: '300px', locked: false },
    { field: 'TaxType', title: i18n.t('impuestos.TaxType'), format: 'TIPOS_CODIGO_IMPUESTO', cell: 'enumTemplate', columnMenu: 'myTemplate', width: '550px', locked: false },
    { field: 'TaxRate', title: i18n.t('impuestos.TaxRate'), columnMenu: 'myTemplate', width: '165px', locked: false },
    { field: 'EquivalenceSurcharge', title: i18n.t('impuestos.equivalence_surcharge'), columnMenu: 'myTemplate', width: '215px', locked: false },
    { field: 'TaxCategory', title: i18n.t('impuestos.TaxCategory'), format: 'TIPOS_CATEGORIA_IMPUESTOS', cell: 'enumTemplate', columnMenu: 'myTemplate', width: '225px', locked: false },
    { field: 'idImpuesto', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', width: '150px', locked: false },
  ] 
}
const mystore = parent({ selectable: true, navigate: false, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
